import type { FilterFn, Row } from '@tanstack/react-table'
import type { ProjectsItem } from '../_project_types/project.types'

export function YieldPerAnnumSortingFn(
  rowA: Row<ProjectsItem>,
  rowB: Row<ProjectsItem>
) {
  const valueA = _getProjectMaxYield(rowA.original)
  const valueB = _getProjectMaxYield(rowB.original)

  return valueA > valueB ? 1 : valueA < valueB ? -1 : 0
}

export function YieldPerAnnumFilterFn(
  row: Row<ProjectsItem>,
  _: string,
  filterValue: any
) {
  const value = _getProjectMaxYield(row.original)

  if (typeof value !== 'number' || !Array.isArray(filterValue)) {
    return true
  }

  return filterValue.length
    ? filterValue.some(
        ({ min = -Infinity, max = Infinity }) => value >= min && value <= max
      )
    : true
}

function _getProjectMaxYield(project: ProjectsItem) {
  if (project.maxExtraYieldPerAnnum) {
    return project.yieldPerAnnum + project.maxExtraYieldPerAnnum
  }
  return project.yieldPerAnnum
}

export const minMaxFilter: FilterFn<ProjectsItem> = (
  row,
  columnId,
  filterValue
) => {
  const value = row.getValue(columnId)

  if (typeof value !== 'number' || !Array.isArray(filterValue)) {
    return true
  }

  return filterValue.length
    ? filterValue.some(
        ({ min = -Infinity, max = Infinity }) => value >= min && value <= max
      )
    : true
}
